// Solomon Portal v1 — frontend structured logger.
// Wraps console.* with a consistent JSON-shaped payload so log scrapers
// (Cloudflare Workers logs, browser devtools) get useful structure.
//
// Production builds keep info+warn+error; debug is silenced unless
// VITE_PORTAL_DEBUG=1 is set at build time.

type LogPayload = Record<string, unknown>;

interface LoggerArgs {
  source: string;
  message: string;
  payload?: LogPayload;
}

const rawEnv = import.meta.env as Record<string, string | undefined>;
const debugEnabled = rawEnv.VITE_PORTAL_DEBUG === '1';

function emit(level: 'debug' | 'info' | 'warn' | 'error', args: LoggerArgs): void {
  if (level === 'debug' && !debugEnabled) return;
  const record = {
    level,
    ts: new Date().toISOString(),
    source: args.source,
    message: args.message,
    ...(args.payload ?? {}),
  };
  console[level === 'debug' ? 'log' : level](JSON.stringify(record));
}

export const logger = {
  debug: (args: LoggerArgs) => emit('debug', args),
  info: (args: LoggerArgs) => emit('info', args),
  warn: (args: LoggerArgs) => emit('warn', args),
  error: (args: LoggerArgs) => emit('error', args),
};
